import { useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { useQuery } from '@apollo/client';
import { useContextMenu } from 'react-contexify';

import LoadingSpinner from '../LoadingSpinner';
import ErrorText from '../ErrorText';
import { CUSTOM_PACKAGES_QUERY } from '../../queries';

type SavedPackagesListProps = {
  className?: string;
  onSavedPackageClick: (pkg: any) => void;
  currentPackageName: string;
};

export default function SavedPackagesList({
  className,
  onSavedPackageClick,
  currentPackageName,
}: SavedPackagesListProps) {
  const [open, setOpen] = useState(false);

  const { loading, error, data } = useQuery(CUSTOM_PACKAGES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const { show } = useContextMenu({
    id: 'delete-package',
  });

  return (
    <div className={`w-full ${className ? className : ''}`}>
      <div
        onClick={() => setOpen((prevState) => !prevState)}
        className="flex flex-row items-center hover:bg-gray-200 cursor-pointer p-1 -ml-2 rounded-lg"
      >
        <div>{open ? <FaAngleUp /> : <FaAngleDown />}</div>
        <div className="pl-1">My Packages</div>
      </div>
      <div
        className={`py-2 pl-5 flex flex-row h-full w-full overflow-auto ${
          open ? 'visible' : 'hidden'
        }`}
      >
        {loading && (
          <LoadingSpinner message={`Getting your saved packages...`} />
        )}
        {!loading && error && <ErrorText message={error.message} />}
        {!loading && !error && data && (
          <ul>
            {data.customPackages.map((pkg, idx) => (
              <li className={`py-0.5`} key={idx}>
                <button
                  type="button"
                  className={`text-left ${
                    currentPackageName === pkg.name
                      ? 'opacity-50 cursor-default'
                      : ''
                  }`}
                  onClick={() =>
                    currentPackageName !== pkg.name && onSavedPackageClick(pkg)
                  }
                  onContextMenu={(e) =>
                    show(e, {
                      props: { id: pkg.id, name: pkg.name },
                    })
                  }
                >
                  {pkg.name}
                </button>
              </li>
            ))}
            {data.customPackages?.length === 0 && <p>{`No saved packages`}</p>}
          </ul>
        )}
      </div>
    </div>
  );
}
